import InboxComponent from "@/components/inbox";

// Kept for the legacy `/inbox/:emailId` deep-link path — renders the same
// two-pane inbox, which reads `:emailId` from the route and redirects to
// the canonical `/inbox?selected=:emailId` form.
export default function InboxDetail() {
  return <InboxComponent />;
}
